import { useAnalysisStore } from '@modules/analysis/store/analysisStore';
import { EqlFieldName } from '@modules/common/constants';
import {
  useFetchQuantifyReport,
  useGetQuantifyCompareQuery,
} from '@modules/quantify/hooks';
import { QuantifyActionType } from '@modules/quantify/store/quantifyActionType';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { FormControlLabel, Switch } from '@mui/material';
import { ChangeEvent, useEffect, useState } from 'react';
import { createAnalyticsTracker } from 'v2/analytics/events';
import { shallow } from 'zustand/shallow';

export const trackQuantifyCategoriesEvent =
  createAnalyticsTracker('quantifyCategories');

export const QuantifyCategoriesToggle = () => {
  const shouldShowCategories = useQuantifyStore(
    ({ visual }) => visual.shouldShowCategories,
  );
  const fetchQuantifyReport = useFetchQuantifyReport();
  const groupBy = useQuantifyStore(({ query }) => query.groupByField);
  const dispatch = useQuantifyStore(({ dispatch }) => dispatch);
  const compareQuery = useGetQuantifyCompareQuery();
  const isChartDataPresent = useQuantifyStore(({ reportData }) =>
    compareQuery
      ? Boolean(reportData.compare.chartDataPoints)
      : Boolean(reportData.quantify.chartDataPoints),
  );

  const { title: name, href } = useAnalysisStore(
    ({ title, href, scope }) => ({ title, href, scope }),
    shallow,
  );
  const [shouldFetchReportData, setShouldFetchReportData] = useState(false);

  useEffect(() => {
    if (shouldFetchReportData) {
      setShouldFetchReportData(false);
      fetchQuantifyReport();
    }
  }, [fetchQuantifyReport, shouldFetchReportData]);

  const onChange = (_: ChangeEvent<HTMLInputElement>, checked: boolean) => {
    dispatch({
      type: QuantifyActionType.SET_VISUAL,
      payload: {
        shouldShowCategories: checked,
      },
    });

    dispatch({
      type: QuantifyActionType.SET_QUERY,
      payload: {
        visibleDataPoints: [],
        shouldShowTopDataPoints: true,
      },
    });

    setShouldFetchReportData(true);

    trackQuantifyCategoriesEvent({
      eventName: checked
        ? 'Quantify Categories - Toggled On'
        : 'Quantify Categories - Toggled Off',
      query: {
        showMeLabel: groupBy?.displayName,
      },
      name,
      link: href,
    });
  };

  if (
    !groupBy ||
    groupBy.field !== EqlFieldName.Entity ||
    !isChartDataPresent
  ) {
    return null;
  }

  return (
    <FormControlLabel
      control={
        <Switch
          checked={shouldShowCategories}
          onChange={onChange}
          size="small"
        />
      }
      label="Show Categories"
      componentsProps={{
        typography: {
          variant: 'body2',
        },
      }}
    />
  );
};
